<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-4"><a href="#/Poisoned_Ground2#Contents-A">Dedication</a></p>
<p class="Body-Center"><span class="Italic">For Jerry</span></p>
<p class="body"></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Poisoned_Ground-3.vue?3be649f8